import { BitfPaginationApiRequestPart } from '@bitf/core/api-call-state/bitf-pagination-api-request-part.builder';

export class BitfGraphQlPaginationApiRequestPart extends BitfPaginationApiRequestPart {
  constructor({ key, initialPagination, options }) {
    super({ key, initialPagination, options });
  }
}
